import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ArrowsClockwise } from "@phosphor-icons/react";
import { TresorerieBlock } from "@/components/commando/TresorerieBlock";
import { ObjectifBlock } from "@/components/commando/ObjectifBlock";
import { PlanBlock } from "@/components/commando/PlanBlock";

// V10 — Commando Business : Trésorerie › Objectif › Plan (moteur déterministe, recalcul à chaque chargement)
export default function CommandoBusiness({ refreshKey }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async (silent) => {
    if (!silent) setLoading(true);
    try { setData((await api.get("/commando/business")).data); } catch { toast.error("Commando Business indisponible"); } finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load, refreshKey]);

  if (loading && !data) return <div className="card-base p-5 mb-4 text-sm text-slate-500" data-testid="cb-loading">Calcul des priorités…</div>;
  if (!data) return null;

  return (
    <div className="space-y-4 mb-6" data-testid="commando-business">
      <div className="flex items-center justify-end">
        <button onClick={() => load(true)} className="inline-flex items-center gap-1.5 text-xs font-bold text-slate-600 hover:text-slate-900" data-testid="cb-refresh">
          <ArrowsClockwise size={14} weight="bold" /> Actualiser les recommandations
        </button>
      </div>
      <TresorerieBlock data={data.tresorerie} />
      <ObjectifBlock data={data.objectif} />
      <PlanBlock plan={data.plan} onChanged={() => load(true)} />
    </div>
  );
}
